import React, { Component } from "react";
import { Pearl } from "components/badges/Pearl";
import { Diamond } from "components/badges/Diamond";
import { Ruby } from "components/badges/Ruby";
import { Sapphire } from "components/badges/Sapphire";
import { Emerald } from "components/badges/Emerald";
import { GlamboxBadge } from "core/glambox/GlamboxBadge";

class GetGlampointsAndBadge extends Component {

    constructor(props) {
        super(props);

        this.glampointsReturn = this.glampointsReturn.bind(this);
    }

    glampointsReturn() {

        let glampoints = 0;
        let points = this.props.rewardInfo;

        for (let i = 0; i < points.length; i++) {
            glampoints += points[i].points;
        }

        return (
            <strong> {glampoints} Glampoints </strong>
        );
    }

    getBadgeIcon = () => {
        let { badge } = this.props.person;
        if (badge === undefined || badge === null) return null;

        switch (badge.badgeId) {
            case 1:
                return <Pearl />;
            case 2:
                return <Emerald />;
            case 3:
                return <Ruby />;
            case 4:
                return <Sapphire />;
            default:
                return <Diamond />;
        }
    };

    renderBadgeIcon = () => {
        let { badge } = this.props.person;
        if (badge === undefined || badge === null) return null;

        return (
            <div className={"d-flex sua_joia"}>
                {this.getBadgeIcon()}
                <div className={"d-flex flex-column"}>
                    <small>Sua joia: </small>
                    <small style={{ fontWeight: 800 }}>{GlamboxBadge.getJewelName(this.props.person.badge.badgeId)}</small>
                </div>
            </div>);
    };

    render() {
        return (
            <div className={"level-2 d-flex justify-between"} style={{ background: "#fff", marginBottom: "30px", flexWrap: "wrap" }}>
                <div className={"p-2 p-lg-5"}>
                    <p style={{ margin: 0 }}>Você possui um saldo de {this.glampointsReturn()} </p>
                </div>
                {this.renderBadgeIcon()}
            </div>
        );
    }
}

export { GetGlampointsAndBadge };